const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function formatIsoDate(iso) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso));
  if (!match) return String(iso);
  const month = MONTHS[Number(match[2]) - 1];
  if (!month) return String(iso);
  return `${month} ${Number(match[3])}, ${match[1]}`;
}

export function formatVerifiedDate(iso) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso));
  if (!match) return String(iso);
  const month = MONTHS[Number(match[2]) - 1];
  if (!month) return String(iso);
  return `${Number(match[3])} ${month} ${match[1]}`;
}

export function formatSiNumber(value) {
  const negative = value < 0;
  const raw = String(Math.abs(value));
  const [whole, fraction] = raw.split(".");
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const body = fraction ? `${grouped}.${fraction}` : grouped;
  return negative ? `-${body}` : body;
}
